import { createComponent } from '../lib';
import { VmHls, VmFile, VmVideo } from '@vime/core';
import { define } from '../lib';
define('vm-hls', VmHls);
define('vm-file', VmFile);
define('vm-video', VmVideo);
;
export default createComponent('vm-hls', new Set(['version', 'libSrc', 'config', 'crossOrigin', 'preload', 'poster', 'controlsList', 'autoPiP', 'disablePiP', 'disableRemotePlayback', 'playbackReady', 'mediaTitle']));
